import React from "react";
import Select from "react-select";
import theme from "../../../Styles/theme.scss";

export interface LilliSelectOption {
  label: string;
  value: string | number;
  [key: string]: unknown;
}

interface LilliSelectProps {
  options: readonly LilliSelectOption[];
  value: LilliSelectOption | null | undefined;
  onChange: (option: LilliSelectOption | null) => void;
  isSearchable?: boolean;
  dataPrivate?: boolean;
  isDisabled?: boolean;
  name?: string;
  placeholder?: string;
  isClearable?: boolean;
  menuPlacement?: "auto" | "bottom" | "top";
  withinModal?: boolean;
  inputStyles?: React.CSSProperties;
  maxMenuHeight?: number;
}

const LilliSelect = ({
  options,
  value,
  onChange,
  isSearchable = false,
  dataPrivate = true,
  isDisabled = false,
  name,
  placeholder,
  isClearable = false,
  menuPlacement = "auto",
  withinModal,
  maxMenuHeight,
  inputStyles = {},
}: LilliSelectProps) => {
  return (
    <Select
      data-private={dataPrivate}
      placeholder={placeholder}
      options={options}
      name={name}
      value={value}
      onChange={onChange}
      isSearchable={isSearchable}
      isClearable={isClearable}
      menuPlacement={menuPlacement}
      maxMenuHeight={maxMenuHeight}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      isDisabled={isDisabled}
      components={{ IndicatorSeparator: () => null }}
      styles={{
        control: (baseStyles, { isFocused }) => ({
          ...baseStyles,
          borderColor: isFocused ? theme.primary3 : theme.neutral3,
          marginTop: 4,
          fontSize: theme.bodyMedium,
          color: theme.neutral7,
          borderRadius: 8,
          ":hover": { borderColor: theme.primary3 },
          boxShadow: "none",
          ...inputStyles,
        }),
        option: (styles, { isFocused }) => ({
          ...styles,
          fontSize: "16px",
          backgroundColor: isFocused ? theme.neutral2 : null,
          color: theme.neutral7,
          ":active": { backgroundColor: theme.neutral3 },
        }),
        menuList: (provided) => ({
          ...provided,
          ...(maxMenuHeight && { maxHeight: maxMenuHeight }),
        }),
        menuPortal: (provided) => ({
          ...provided,
          zIndex: withinModal ? 550 : "auto",
        }),
      }}
    />
  );
};

export default LilliSelect;
